// extracted by mini-css-extract-plugin
export default {"keypad":"keypad_keypad","key":"keypad_key","functionKey":"keypad_functionKey"};